import { render, staticRenderFns } from "./ContasPagarForm.vue?vue&type=template&id=c31a9452&scoped=true"
import script from "./ContasPagarForm.vue?vue&type=script&lang=js"
export * from "./ContasPagarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31a9452",
  null
  
)

export default component.exports